import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isExecuteCommandArgs(obj: any): CsvConfigJsonResult {
  let valid = true;
  let errors = [];
  if (obj.deviceSerialNumber === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'deviceSerialNumber'});
  } else if (typeof obj.deviceSerialNumber !== 'string') {
    valid = false;
    errors.push({code: 'notText', key: 'deviceSerialNumber', value: obj.deviceSerialNumber});
  }
  if (obj.schema === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'schema'});
  } else if (typeof obj.schema !== 'string') {
    valid = false;
    errors.push({code: 'notText', key: 'schema', value: obj.schema});
  }

  if (obj.command === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'command'});
  } else if (typeof obj.command !== 'string') {
    valid = false;
    errors.push({code: 'notText', key: 'command', value: obj.command});
  }

  if (obj.askParamsToUser === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'askParamsToUser'});
  } else if (typeof obj.askParamsToUser !== 'boolean') {
    valid = false;
    errors.push({code: 'notBoolean', key: 'askParamsToUser', value: obj.askParamsToUser});
  }

  return {result: valid, errors: errors};
}
